export function appendToParent(parent,child) {
    return parent.appendChild(child)
}
